import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ChapterPreview } from './components/ChapterPreview';
import { ProtocolTeaser } from './components/ProtocolTeaser';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { SalesFAQ } from './components/SalesFAQ';
import { FinalCTA } from './components/FinalCTA';
import { SalesFooter } from './components/SalesFooter';
export function App() {
  return <div className="min-h-screen bg-cream font-body text-charcoal selection:bg-gold-brand/30 selection:text-charcoal" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ChapterPreview data-id="element-4" />
      <ProtocolTeaser data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <SalesFAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <SalesFooter data-id="element-11" />
    </div>;
}